import { Link } from '@components/Link'
import { Logo } from '@components/Logo'
import { trackGTM } from '@helpers/core/trackGTM'

export const LogoLink = ({
  url,
  classOverride,
}: {
  url: string
  classOverride?: string
}) => {
  return (
    <Link
      url={url}
      className='outline-none focus:outline-teal'
      onClick={() => {
        trackGTM({
          event: 'logo_click',
          // eslint-disable-next-line camelcase
          cta_text: 'Logo',
          // eslint-disable-next-line camelcase
          destination_url: url,
        })
      }}
      aria-label='N26 logo'
    >
      <Logo classOverride={classOverride} />
    </Link>
  )
}
